export const enum myAgencyListRowTrackId {
  creatorName = 'foam-myagency-listRow-creatorName',
  creatorBio = 'foam-myagency-listRow-creatorBio',
  creatorVerticals = 'foam-myagency-listRow-creatorVerticals',
  creatorAge = 'foam-myagency-listRow-creatorAge',
  creatorGender = 'foam-myagency-listRow-creatorGender',
  creatorLocation = 'foam-myagency-listRow-creatorLocation',
  creatorInstagramAudience = 'foam-myagency-listRow-creatorInstagramAudience',
  creatorTikTokAudience = 'foam-myagency-listRow-creatorTikTokAudience',
  creatorYouTubeAudience = 'foam-myagency-listRow-creatorYouTubeAudience',
  creatorSnapchatAudience = 'foam-myagency-listRow-creatorSnapchatAudience',
  creatorTotalAudience = 'foam-myagency-listRow-creatorTotalAudience',
  creatorTalentManagerList = 'foam-myagency-listRow-creatorTalentManagerList',
  creatorWebLinks = 'foam-myagency-listRow-creatorWebLinks',
}

export const enum creatorMarketerListRowTrackId {
  creatorName = 'foam-creatormarketer-listRow-creatorName',
  creatorBio = 'foam-creatormarketer-listRow-creatorBio',
  creatorVerticals = 'foam-creatormarketer-listRow-creatorVerticals',
  creatorAge = 'foam-creatormarketer-listRow-creatorAge',
  creatorGender = 'foam-creatormarketer-listRow-creatorGender',
  creatorLocation = 'foam-creatormarketer-listRow-creatorLocation',
  creatorInstagramAudience = 'foam-creatormarketer-listRow-creatorInstagramAudience',
  creatorTikTokAudience = 'foam-creatormarketer-listRow-creatorTikTokAudience',
  creatorYouTubeAudience = 'foam-creatormarketer-listRow-creatorYouTubeAudience',
  creatorSnapchatAudience = 'foam-creatormarketer-listRow-creatorSnapchatAudience',
  creatorTotalAudience = 'foam-creatormarketer-listRow-creatorTotalAudience',
  creatorTalentManagerList = 'foam-creatormarketer-listRow-creatorTalentManagerList',
  creatorWebLinks = 'foam-creatormarketer-listRow-creatorWebLinks',
}
